import {
  Badge,
  Card,
  HStack,
  Heading,
  SimpleGrid,
  Stat,
  Text,
} from "@chakra-ui/react"
import type { FeedbackSummary } from "../../../client"

interface FeedbackSummaryCardProps {
  feedback: FeedbackSummary
}

export default function FeedbackSummaryCard({
  feedback,
}: FeedbackSummaryCardProps) {
  if (feedback.total_count === 0) {
    return (
      <Card.Root h="full">
        <Card.Body>
          <Heading size="md" mb={4}>
            Student Feedback
          </Heading>
          <Text color="gray.500">No feedback submitted for this question</Text>
        </Card.Body>
      </Card.Root>
    )
  }

  return (
    <Card.Root h="full">
      <Card.Body>
        <HStack justify="space-between" mb={4}>
          <Heading size="md">Student Feedback</Heading>
          <Badge colorScheme="blue" fontSize="md">
            {feedback.total_count}{" "}
            {feedback.total_count === 1 ? "item" : "items"}
          </Badge>
        </HStack>

        <SimpleGrid columns={{ base: 1, md: 3 }} gap={4}>
          <Stat.Root>
            <Stat.Label>Unread</Stat.Label>
            <Stat.ValueText>{feedback.unread_count}</Stat.ValueText>
          </Stat.Root>

          <Stat.Root>
            <Stat.Label>Read</Stat.Label>
            <Stat.ValueText>{feedback.read_count}</Stat.ValueText>
          </Stat.Root>

          <Stat.Root>
            <Stat.Label>Resolved</Stat.Label>
            <Stat.ValueText>{feedback.resolved_count}</Stat.ValueText>
          </Stat.Root>
        </SimpleGrid>
      </Card.Body>
    </Card.Root>
  )
}
